import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {AppStore} from 'js/stores'; // singleton stores
import {InputRadio} from 'js/components/form';
import styles from 'css/screens/home.css';

@observer
/**
 * List
 */
export default class List extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this.change = this.change.bind(this);
  }

  /**
   * change
   * @param {object} e element
   */
  change(e) {
    AppStore.updateQuestionChecked({
      id: e.target.name,
      checked: e.target.value,
    });
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const items = AppStore.questions.map((item, index) => {
      const yesAttributes = {
        id: `yes-${item.id}`,
        name: item.id,
        value: 'yes',
        checked: item.checked,
        onChange: this.change,
      };

      const noAttributes = {
        id: `no-${item.id}`,
        name: item.id,
        value: 'no',
        checked: item.checked,
        onChange: this.change,
      };

      return (
        <div key={index} className={styles.table}>
          <span>Q{index + 1}</span>
          <span>{item.text}</span>
          <span>
            <div className={styles.radio}>
              <InputRadio {...yesAttributes}>はい</InputRadio>
              <InputRadio {...noAttributes}>いいえ</InputRadio>
            </div>
          </span>
        </div>
      );
    });

    return (
      <div className={styles.questionBlock}>
        <div className={styles.question}>
          {items}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/home/list.js